import { LitElement, css, html } from "lit";
import { customElement } from "lit/decorators.js";
import { consume } from "@lit/context";
import { EnabledFeatures, enabledFeatures } from "../contexts/features-context";
import { appColorScheme } from "../contexts/theme-context";
import { SignalWatcher } from "@lit-labs/signals";
import type { ColorSchemeChangeEvent } from "./color-scheme-select";
import "./color-scheme-select";

@customElement("ptc-color-scheme-signal-watcher")
export class ColorSchemeSignalWatcher extends SignalWatcher(LitElement) {
    @consume({ context: enabledFeatures, subscribe: true })
    features: EnabledFeatures;

    #onChange(ev: ColorSchemeChangeEvent) {
        appColorScheme.set(ev.detail);

        localStorage.setItem("color-scheme", appColorScheme.get());
        document.documentElement.setAttribute("data-color-scheme", appColorScheme.get());
    }

    connectedCallback() {
        super.connectedCallback();
        document.documentElement.setAttribute("data-color-scheme", appColorScheme.get());
    }

    static styles = [
        css`
            ptc-color-scheme-select {
                margin: 0.25em 0.5em 0 0.5em;
            }
        `,
    ];

    render() {
        return html`
            <ptc-color-scheme-select @color-change=${this.#onChange}>
                <slot></slot>
            </ptc-color-scheme-select>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ptc-color-scheme-signal-watcher": ColorSchemeSignalWatcher;
    }
}
